import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'BOEs/state',
    initialState: {
        drawerOpen: false,
        selectedBOE: {},
        isEdit:false,
        sortedColumn: () => {},
    },
    reducers: {
        setSelectedBOE: (state, action) => {
            state.selectedBOE = action.payload
            state.isEdit = true
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setDrawerOpen: (state) => {
            state.drawerOpen = true
        },
        setDrawerClose: (state) => {
            state.drawerOpen = false
        },
    },
})

export const { 
    setSelectedBOE, 
    setDrawerOpen, 
    setDrawerClose,
    setSortedColumn
} = stateSlice.actions

export default stateSlice.reducer
